import {WaitingQueueInfo} from "../logic/types/waitingQueue.types";
import {useRegisterWaitingQueueMutation} from "../logic/quries/waitingQueue.queries";
import {useSessionStore} from "src/services/session";
import {isServiceUnavailableError} from "src/utils/error.utils";
import {Artist, convertArtistToType} from "src/utils/artist.utils";

type useRegisterQueueParams = {
  artist: Artist;
  onServiceUnavailable: () => void;
};

export const useRegisterQueue = ({
  artist,
  onServiceUnavailable,
}: useRegisterQueueParams) => {
  const registerWaitingQueueMutation = useRegisterWaitingQueueMutation();

  const registerQueue = async (): Promise<WaitingQueueInfo> => {
    useSessionStore.getState().setSessionRemainingSeconds(5 * 60);
    try {
      const response = await registerWaitingQueueMutation.mutateAsync({
        data: {
          type: convertArtistToType(artist),
        },
      });
      console.log(response);
      return response;
    } catch (error) {
      if (isServiceUnavailableError(error)) {
        onServiceUnavailable();
      }
      console.error(error);
      throw error;
    }
  };

  return {registerQueue};
};
